function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "drawing",
  transform: "translate(0.000000, -1.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M24,10.7435102 L20.468116,14.9767 L16.8999479,14.9767 C16.436599,17.2588038 14.4187868,18.9766 12,18.9766 C9.23871525,18.9766 7,16.7378847 7,13.9766 C7,11.2153153 9.23871525,8.9766 12,8.9766 L12,10.9766 C10.3432847,10.9766 9,12.3198847 9,13.9766 C9,15.6333153 10.3432847,16.9766 12,16.9766 C13.6567153,16.9766 15,15.6333153 15,13.9766 L15.0001,9.60647822 L18.1147231,5.9766 L2,5.9766 L2,21.9766 L24,21.9766 L24,10.7435102 Z M26,8.3463817 L26,23.9766 L0,23.9766 L0,3.9766 L19.8308265,3.9766 L22.3848862,1.00001977 L27.9293146,6.03397418 L26,8.3463817 Z M22.5633138,3.86338023 L17.0001,10.3469218 L17.0001,12.9767 L19.532084,12.9767 L25.1648854,6.22542582 L22.5633138,3.86338023 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "23px",
    viewBox: "0 0 28 23",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/drawing.f770ad6f.svg";
export { SvgComponent as ReactComponent };